export const isAcceptanceTest = () => {
  return !!window.navigator.webdriver;
};
